<template>
  <div class="content-page delivery-page">
    <el-tabs v-model="activeName" type="card" v-if="true">
      <el-tab-pane label="达达配送" name="dada">
        <div class="bd">
          <div class="tab-header" v-if="!isBindShop || !isBindAccount">
            <el-button
              type="primary"
              size="small"
              :disabled="isBindAccount"
              @click="bindAccount"
              v-if="!isBindAccount"
              >{{ isBindAccount ? "已绑定" : "绑定达达商户账号" }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isBindAccount && !isBindShop"
              :disabled="isBindShop"
              @click="bindShop"
              plain
              >{{ isBindShop ? "已绑定" : "绑定达达店铺" }}</el-button
            >
          </div>
          <div class="tab-content">
            <div class="list">
              <el-table :data="shopList" style="width: 100%">
                <el-table-column label="门店名称">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.stationName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="门店编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.originShopId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="所在区域">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.areaName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="商户编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.merchantId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" header-align="right">
                  <template slot-scope="scope">
                    <div class="float-right">
                      <el-button
                        size="small"
                        type="primary"
                        @click="edit(scope.$index)"
                        plain
                        >编辑</el-button
                      >
                      <el-button
                        size="small"
                        type="danger"
                        @click="del(scope.$index)"
                        plain
                        >解绑</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pageSize"
                background
                layout="prev, pager, next, jumper"
                :total="shopList.length"
              ></el-pagination>
            </div>
          </div></div
      ></el-tab-pane>
      <el-tab-pane label="聚合配送" name="maiyatian">
        <div class="bd">
          <div class="tab-header" v-if="!isBindShop">
            <el-button
              type="primary"
              size="small"
              v-if="!isBindShop"
              :disabled="isBindShop"
              @click="bindMTShop"
              plain
              >{{ isBindShop ? "已绑定" : "添加麦芽田门店" }}</el-button
            >
          </div>
          <div class="tab-content">
            <div class="list">
              <el-table :data="shopList" style="width: 100%">
                <el-table-column label="门店名称">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.enterpriseName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="门店编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.merchantId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="所在区域">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.address }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="商户编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.shoperUserId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="审核状态">
                  <template slot-scope="scope">
                    <div class="tag-name">
                      {{ mytStatusObj[scope.row.status] }}
                      <el-link
                        v-if="scope.row.status == 3"
                        :underline="false"
                        type="danger"
                        >（{{ scope.row.note }}）</el-link
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" header-align="right">
                  <template slot-scope="scope">
                    <div class="float-right">
                      <!-- v-if="scope.row.status == 3" -->
                      <!-- <el-button
                    v-if="scope.row.account || scope.row.password"
                    size="small"
                    type="primary"
                    @click="isShowAPDialog = true"
                    >查看账密</el-button
                  > -->
                      <el-button
                        v-if="scope.row.status == 1"
                        size="small"
                        type="primary"
                        @click="edit(scope.$index)"
                        plain
                        >编辑</el-button
                      >
                      <el-button
                        v-if="scope.row.manageUrl"
                        size="small"
                        type="primary"
                        @click="showAuthQrcode(scope.row.manageUrl)"
                        plain
                        >管理码</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pageSize"
                background
                layout="prev, pager, next, jumper"
                :total="shopList.length"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="闪送配送" name="shansong">
        <div class="bd">
          <div class="tab-header" v-if="!isBindShop || !isBindAccount">
            <el-link
              type="primary"
              :underline="false"
              style="margin-right: 5px"
              v-if="ssStatus >= 0 && ssStatus != 2"
              >{{ ssStatusObj[ssStatus] }}</el-link
            >
            <el-button
              type="primary"
              size="small"
              :disabled="isBindAccount && ssStatus == 2"
              @click="bindAccount"
              v-if="!isBindAccount || ssStatus == 3"
              >{{
                isBindAccount && ssStatus == 2 ? "已绑定" : "绑定闪送商户账号"
              }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isBindAccount && !isBindShop && ssStatus == 2"
              :disabled="isBindShop"
              @click="bindShop"
              plain
              >{{ isBindShop ? "已绑定" : "绑定闪送店铺" }}</el-button
            >
          </div>
          <div class="tab-content">
            <div class="list">
              <el-table :data="shopList" style="width: 100%">
                <el-table-column label="门店名称">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.stationName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="门店编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.originShopId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="所在区域">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.areaName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="商户编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.merchantId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" header-align="right">
                  <template slot-scope="scope">
                    <div class="float-right">
                      <el-button
                        size="small"
                        type="primary"
                        @click="edit(scope.$index)"
                        plain
                        >编辑</el-button
                      >
                      <el-button
                        size="small"
                        type="danger"
                        @click="del(scope.$index)"
                        plain
                        >解绑</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pageSize"
                background
                layout="prev, pager, next, jumper"
                :total="shopList.length"
              ></el-pagination>
            </div>
          </div></div
      ></el-tab-pane>
      <el-tab-pane label="美团配送" name="meituan">
        <div class="bd">
          <div class="tab-header" v-if="!isBindShop">
            <el-button
              type="primary"
              size="small"
              v-if="!isBindShop"
              :disabled="isBindShop"
              @click="bindMTShop"
              plain
              >{{ isBindShop ? "已绑定" : "添加美团门店" }}</el-button
            >
          </div>
          <div class="tab-content">
            <div class="list">
              <el-table :data="shopList" style="width: 100%">
                <el-table-column label="门店名称">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.enterpriseName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="门店编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.merchantId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="所在区域">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.address }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="商户编号">
                  <template slot-scope="scope">
                    <div class="tag-name">{{ scope.row.shoperUserId }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="审核状态">
                  <template slot-scope="scope">
                    <div class="tag-name">
                      {{ ssStatusObj[scope.row.status] }}
                      <el-link
                        v-if="scope.row.status == 3"
                        :underline="false"
                        type="danger"
                        >（{{ scope.row.note }}）</el-link
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" header-align="right">
                  <template slot-scope="scope">
                    <div class="float-right">
                      <el-button
                        v-if="scope.row.account || scope.row.password"
                        size="small"
                        type="primary"
                        @click="isShowAPDialog = true"
                        >查看账密</el-button
                      >
                      <el-button
                        v-if="scope.row.status == 3"
                        size="small"
                        type="primary"
                        @click="edit(scope.$index)"
                        plain
                        >编辑</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pageSize"
                background
                layout="prev, pager, next, jumper"
                :total="shopList.length"
              ></el-pagination>
            </div>
          </div></div
      ></el-tab-pane>
       <el-tab-pane label="蜂鸟配送" name="ele">
        <div class="bd">
          <div class="tab-content">
            <el-form ref="form" :model="eleInfo" label-width="120px">
              <el-form-item label="认证状态：">
                <el-link
                  :type="eleInfo ? 'success' : 'danger'"
                  :underline="false"
                  >{{ eleInfo ? "已认证" : "未认证" }}</el-link
                >
                <el-button
                  style="margin-left: 10px;"
                  type="primary"
                  size="mini"
                  v-if="!eleInfo"
                  @click="getAuthUrl"
                  >去认证</el-button
                >
              </el-form-item>
              <el-form-item label="绑定账号：" v-if="eleInfo">
                {{ eleInfo.phone }}
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane> -->
    </el-tabs>

    <el-dialog
      :visible.sync="dialogBindAccountVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        绑定{{ activeNameObj[activeName] }}商户账号
      </div>
      <el-form
        :model="bindAccountForm"
        :rules="
          bindAccountForm.bindingMode
            ? activeName == 'dada'
              ? bindAccountFormRule2
              : bindSSAccountFormRule2
            : activeName == 'dada'
            ? bindAccountFormRule1
            : bindSSAccountFormRule1
        "
        ref="bindAccountForm"
        label-width="88px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <el-form-item label="绑定模式">
          <el-radio-group v-model="bindAccountForm.bindingMode">
            <el-radio :label="0">绑定已有账号</el-radio>
            <el-radio :label="1">新建账号</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="!bindAccountForm.bindingMode">
          <el-form-item
            :label="`${activeNameObj[activeName]}商户ID`"
            prop="merchantId"
            v-show="activeName == 'dada'"
          >
            <el-input
              v-model="bindAccountForm.merchantId"
              :placeholder="`请填写${activeNameObj[activeName]}商户ID`"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="企业全称"
            prop="enterpriseName1"
            v-show="activeName == 'dada'"
          >
            <el-input
              v-model="bindAccountForm.enterpriseName1"
              placeholder="请填写企业全称"
            ></el-input>
          </el-form-item>
        </div>
        <div v-show="bindAccountForm.bindingMode">
          <el-form-item label="商户手机号" prop="mobile" v-show="ssStatus != 3">
            <el-input
              v-model="bindAccountForm.mobile"
              placeholder="请填写手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="smsCode" v-show="ssStatus != 3">
            <el-input
              v-model="bindAccountForm.smsCode"
              class="vcode-input"
              placeholder="请输入短信验证码"
            >
              <template slot="append">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="timer ? '' : sendRegisterSmsCode()"
                  >{{ timer ? `${timeCount}s后重发` : "获取验证码" }}</el-link
                >
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="企业全称" prop="enterpriseName2">
            <el-input
              v-model="bindAccountForm.enterpriseName2"
              placeholder="请填写企业全称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="业务类型"
            prop="business"
            v-show="activeName == 'shansong'"
          >
            <el-select v-model="bindAccountForm.business" placeholder="请选择业务类型">
              <el-option
                v-for="item in businessOptions"
                :key="item.type"
                :label="item.typeName"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商户城市" prop="cityName">
            <el-cascader
              v-model="bindAccountForm.cityNameArryay"
              :options="cityOptions"
              @change="cityChange"
              ref="BCShopCityName"
              :props="{ expandTrigger: 'hover', value: 'value' }"
              placeholder="请选择城市"
            ></el-cascader>
          </el-form-item>
          <el-form-item
            label="企业地址"
            prop="enterpriseAddress"
            v-show="activeName == 'dada'"
          >
            <el-input
              v-model="bindAccountForm.enterpriseAddress"
              placeholder="请填写企业地址"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="店铺地址"
            prop="enterpriseAddress"
            v-show="activeName == 'shansong'"
          >
            <el-input
              v-model="bindAccountForm.enterpriseAddress"
              placeholder="请填写店铺地址"
            >
              <!-- <template slot="append">
                <el-button @click="showBCDialogMap">去定位</el-button>
              </template> -->
            </el-input>
          </el-form-item>
          <el-form-item label="经纬度:" prop="center">
            <el-input
              v-model="mapCenterInputText"
              placeholder="请填写经纬度"
              @blur="mapCenterInputTextBlur(bindAccountForm)"
            >
              <template slot="append">
                <el-button type="primary" @click="showDialogMap()">去获取</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="联系人姓名"
            prop="contactName"
            v-show="activeName == 'dada'"
          >
            <el-input
              v-model="bindAccountForm.contactName"
              placeholder="请填写联系人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input
              v-model="bindAccountForm.contactPhone"
              placeholder="请填写联系人电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱地址" prop="email" v-show="activeName == 'dada'">
            <el-input
              v-model="bindAccountForm.email"
              placeholder="请填写邮箱地址"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="身份证正面"
            prop="frontIdcard"
            v-show="activeName == 'shansong'"
          >
            <el-upload
              class="uploader"
              action="/edcmanageapi/Shansong_fileUpload"
              :show-file-list="false"
              :http-request="
                (e) => {
                  handleSuccess(e, 'frontIdcard');
                }
              "
            >
              <img
                v-if="bindAccountForm.frontIdcard"
                :src="bindAccountForm.frontIdcard"
                class="uploader-img"
              />
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="身份证反面"
            prop="reverseIdcard"
            v-show="activeName == 'shansong'"
          >
            <el-upload
              class="uploader"
              action="/edcmanageapi/Shansong_fileUpload"
              :show-file-list="false"
              :http-request="
                (e) => {
                  handleSuccess(e, 'reverseIdcard');
                }
              "
            >
              <img
                v-if="bindAccountForm.reverseIdcard"
                :src="bindAccountForm.reverseIdcard"
                class="uploader-img"
              />
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="营业执照"
            prop="businessLicense"
            v-show="activeName == 'shansong'"
          >
            <el-upload
              class="uploader"
              action="/edcmanageapi/Shansong_fileUpload"
              :show-file-list="false"
              :http-request="
                (e) => {
                  handleSuccess(e, 'businessLicense');
                }
              "
            >
              <img
                v-if="bindAccountForm.businessLicense"
                :src="bindAccountForm.businessLicense"
                class="uploader-img"
              />
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="门店照" prop="facade" v-show="activeName == 'shansong'">
            <el-upload
              class="uploader"
              action="/edcmanageapi/Shansong_fileUpload"
              :show-file-list="false"
              :http-request="
                (e) => {
                  handleSuccess(e, 'facade');
                }
              "
            >
              <img
                v-if="bindAccountForm.facade"
                :src="bindAccountForm.facade"
                class="uploader-img"
              />
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <el-dialog
        width="510px"
        :visible.sync="dialogBCMapVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="true"
      >
        <div slot="title" class="dialog-title">地图定位</div>
        <!-- <baidu-map
          v-if="dialogBCMapVisible"
          class="map"
          :center="center"
          :zoom="zoom"
          @ready="mapBCReadyHandler"
          @click="getBCPoint"
          :scroll-wheel-zoom="true"
        >
          <bm-control :offset="{ width: '10px', height: '10px' }">
            <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
          </bm-control>
          <bm-local-search
            :keyword="keyword"
            :auto-viewport="true"
            :location="location"
            zoom="12.8"
            style="display: none"
          ></bm-local-search>
          <bm-marker :position="postionMap">
            <bm-info-window
              :show="show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
              style="font-size: 14px"
            >
              <p>站点：{{ add.siteName }}</p>
              <p>站点地址：{{ add.site }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map> -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveBCStationAddress">保存</el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createBindAccount" :loading="isSubmit">{{
          activeName == "shansong" && !bindAccountForm.bindingMode
            ? "立即授权"
            : "立即创建"
        }}</el-button>
        <el-button @click="dialogBindAccountVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogBindShopVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        {{
          isBindShop && (activeName == "meituan" || activeName == "maiyatian")
            ? "编辑"
            : "绑定"
        }}{{ activeNameObj[activeName] }}店铺
      </div>
      <el-form
        :model="bindShopForm"
        :rules="
          bindShopForm.bindingMode
            ? activeName == 'dada' || activeName == 'meituan' || activeName == 'maiyatian'
              ? bindShopFormRule2
              : bindSSShopFormRule2
            : bindShopFormRule1
        "
        ref="bindShopForm"
        label-width="88px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
        @close="closeBindShopForm"
      >
        <el-form-item
          label="绑定模式"
          v-if="!isBindShop && activeName != 'meituan' && activeName != 'maiyatian'"
        >
          <el-radio-group v-model="bindShopForm.bindingMode">
            <el-radio :label="0">绑定已有门店</el-radio>
            <el-radio :label="1">新建门店</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="!bindShopForm.bindingMode">
          <el-form-item :label="`${activeNameObj[activeName]}商户ID`" prop="merchantId">
            <el-input
              :disabled="true"
              v-model="bindShopForm.merchantId"
              :placeholder="`请填写${activeNameObj[activeName]}商户ID`"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="`${activeNameObj[activeName]}门店ID`"
            prop="originShopId"
            v-show="activeName == 'dada'"
          >
            <el-input
              v-model="bindShopForm.originShopId"
              :placeholder="`请填写${activeNameObj[activeName]}门店ID`"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="`${activeNameObj[activeName]}门店ID`"
            prop="originShopId"
            v-show="activeName == 'shansong'"
          >
            <el-select v-model="bindShopForm.originShopId" placeholder="请选择门店ID">
              <el-option
                v-for="item in allStore"
                :key="item.storeId"
                :label="item.storeName"
                :value="item.storeId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-show="bindShopForm.bindingMode">
          <el-form-item label="门店名称" prop="stationName">
            <el-input
              v-model="bindShopForm.stationName"
              placeholder="请填写门店名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="business" v-if="activeName != 'meituan'">
            <el-select v-model="bindShopForm.business" placeholder="请选择业务类型">
              <el-option
                v-for="item in businessOptions"
                :key="item.type"
                :label="item.typeName"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型" prop="mtBusiness" v-if="activeName == 'meituan'">
            <el-cascader
              v-model="bindShopForm.mtBusiness"
              placeholder="请选择业务类型"
              :options="MTBusinessOptions"
            ></el-cascader>
          </el-form-item>
          <el-form-item
            label="门店所在地"
            prop="cityName"
            v-if="activeName != 'maiyatian'"
          >
            <el-cascader
              v-model="bindShopForm.cityNameArryay"
              @change="cityNameCascaderHandler"
              :options="cityOptions"
              ref="shopCityName"
              :props="{ expandTrigger: 'hover', value: 'value' }"
              placeholder="请选择门店所在地"
            ></el-cascader>
          </el-form-item>
          <el-form-item
            label="门店所在地"
            prop="cityName"
            v-if="activeName == 'maiyatian'"
          >
            <el-cascader
              v-model="bindShopForm.cityNameArryay"
              @change="cityNameForCodeCascaderHandler"
              :options="cityOptionsForCode"
              ref="shopCityName"
              :props="{ expandTrigger: 'hover', value: 'value' }"
              placeholder="请选择门店所在地"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="店铺地址" prop="stationAddress">
            <el-input v-model="bindShopForm.stationAddress" placeholder="请填写店铺地址">
              <!-- <template slot="append">
                <el-button @click="showDialogMap">去定位</el-button>
              </template> -->
            </el-input>
          </el-form-item>
          <el-form-item label="经纬度:" prop="center">
            <el-input
              v-model="mapCenterInputText"
              placeholder="请填写经纬度"
              @blur="mapCenterInputTextBlur(bindShopForm)"
            >
              <template slot="append">
                <el-button type="primary" @click="showDialogMap()">去获取</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="门牌号" prop="areaName" v-show="activeName == 'shansong'">
            <el-input
              v-model="bindShopForm.areaName"
              placeholder="请填写门牌号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="门牌号"
            prop="addressDetail"
            v-show="activeName == 'meituan' || activeName == 'maiyatian'"
          >
            <el-input
              v-model="bindShopForm.addressDetail"
              placeholder="请填写门牌号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系人姓名"
            prop="contactName"
            v-show="
              activeName == 'dada' || activeName == 'meituan' || activeName == 'maiyatian'
            "
          >
            <el-input
              v-model="bindShopForm.contactName"
              placeholder="请填写联系人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="phone">
            <el-input
              v-model="bindShopForm.phone"
              placeholder="请填写联系人电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业时间" prop="businessHours">
            <el-time-select
              v-model="bindShopForm.startHour"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
              }"
              placeholder="请选择开始时间"
            ></el-time-select>
            -
            <el-time-select
              v-model="bindShopForm.endHour"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
              }"
              placeholder="请选择结束时间"
            ></el-time-select>
          </el-form-item>
        </div>
      </el-form>
      <el-dialog
        width="510px"
        :visible.sync="dialogMapVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="true"
      >
        <div slot="title" class="dialog-title">地图定位</div>
        <!-- <baidu-map
          v-if="dialogMapVisible"
          class="map"
          :center="center"
          :zoom="zoom"
          @ready="mapReadyHandler"
          @click="getPoint"
          :scroll-wheel-zoom="true"
        >
          <bm-control :offset="{ width: '10px', height: '10px' }">
            <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
          </bm-control>
          <bm-local-search
            :keyword="keyword"
            :auto-viewport="true"
            :location="location"
            zoom="12.8"
            style="display: none"
          ></bm-local-search>
          <bm-marker :position="postionMap">
            <bm-info-window
              :show="show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
              style="font-size: 14px"
            >
              <p>站点：{{ add.siteName }}</p>
              <p>站点地址：{{ add.site }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map> -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveStationAddress">保存</el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createBindShop" :loading="isSubmit">{{
          isBindShop && activeName == "meituan" ? "编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogBindShopVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="510px"
      :visible.sync="isShowAPDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <div slot="title" class="dialog-title">查看账密</div>
      <el-form label-width="80px">
        <el-form-item label="账号："
          >{{ shopList[0] && shopList[0].account }}
        </el-form-item>
        <el-form-item label="密码："
          >{{ shopList[0] && shopList[0].password }}
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="visibleQrcodeImg"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="管理码"
      width="380px"
    >
      <div style="text-align: center">
        <qrcode :value="qrcodeImg" :options="{ size: 300 }" class="qrcode"></qrcode>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMerchant,
  getMerchantMT,
  getShansongMerchant,
  getMerchantMYT,
  addMerchant,
  addSSMerchant,
  addMYTMerchant,
  reAddSSMerchant,
  getMerchantForCheck,
  getShansongMerchantForCheck,
  bindMerchant,
  addShop,
  addSSShop,
  bindShop,
  bindSSShop,
  getBusiness,
  getShansongBusiness,
  getMYTBusiness,
  updateShop,
  updateShopUnbind,
  getShopInfoEle,
  getAuthUrl,
  ssUploadImg,
  sendRegisterSmsCode,
  getAllStore,
  updateMYTShop,
} from "@/api";
import { gg2bd, bd2gg } from "@/utils/map.js";
import cityJson from "@/assets/js/cityData.json";
import cityJsonForCode from "@/assets/js/citys.json";
import qrcode from "@xkeshi/vue-qrcode";

import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      visibleQrcodeImg: false,
      qrcodeImg: "",
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      shopList: [],
      pageSize: 5,
      dialogBindAccountVisible: false,
      dialogBindShopVisible: false,
      dialogMapVisible: false,
      dialogBCMapVisible: false,
      bindAccountForm: {
        bindingMode: 0,
        merchantId: "",
        enterpriseName1: "",
        mobile: "",
        smsCode: "",
        enterpriseName2: "",
        business: "",
        cityName: "",
        cityNameArryay: [],
        enterpriseAddress: "",
        contactName: "",
        contactPhone: "",
        email: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        frontIdcard: "",
        reverseIdcard: "",
        businessLicense: "",
        facade: "",
        lng: "",
        lat: "",
      },
      ssStatus: -1,
      ssStatusObj: {
        0: "审核中",
        1: "已提交绑定申请",
        2: "绑定成功",
        3: "绑定失败",
      },
      mytStatusObj: {
        0: "审核中",
        1: "已绑定",
        2: "审核失败",
      },
      isBindAccount: false,
      isBindShop: false,
      bindAccountFormRule1: {
        merchantId: [
          {
            required: true,
            message: "请填写达达商户ID",
            trigger: "blur",
          },
        ],
        enterpriseName1: [
          {
            required: true,
            message: "请填写企业全称",
            trigger: "blur",
          },
        ],
      },
      bindSSAccountFormRule1: {},
      bindAccountFormRule2: {
        mobile: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        enterpriseName2: [
          {
            required: true,
            message: "请填写企业全称",
            trigger: "blur",
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择城市",
            trigger: "blur",
          },
        ],
        enterpriseAddress: [
          {
            required: true,
            message: "请填写企业地址",
            trigger: "blur",
          },
        ],
        contactName: [
          {
            required: true,
            message: "请填写联系人姓名",
            trigger: "blur",
          },
        ],
        contactPhone: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
            required: true,
          },
        ],
      },
      bindSSAccountFormRule2: {
        mobile: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        enterpriseName2: [
          {
            required: true,
            message: "请填写企业全称",
            trigger: "blur",
          },
        ],
        business: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "blur",
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择城市",
            trigger: "blur",
          },
        ],
        enterpriseAddress: [
          {
            required: true,
            message: "请填写企业地址",
            trigger: "blur",
          },
        ],
        contactPhone: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        frontIdcard: [
          {
            required: true,
            message: "请上传身份证正面",
            trigger: "blur",
          },
        ],
        reverseIdcard: [
          {
            required: true,
            message: "请上传身份证反面",
            trigger: "blur",
          },
        ],
        businessLicense: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "blur",
          },
        ],
        facade: [
          {
            required: true,
            message: "请上传门店照",
            trigger: "blur",
          },
        ],
      },
      bindShopForm: {
        bindingMode: 0,
        merchantId: "",
        originShopId: "",
        stationName: "",
        business: "",
        mtBusiness: [],
        cityName: "",
        cityNameArryay: [],
        stationAddress: "",
        lng: "",
        lat: "",
        contactName: "",
        phone: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        areaName: "",
        addressDetail: "",
        startHour: "08:00",
        endHour: "23:59",
      },
      bindShopFormRule1: {
        merchantId: [
          {
            required: true,
            message: "请填写商户ID",
            trigger: "blur",
          },
        ],
        originShopId: [
          {
            required: true,
            message: "请填写门店ID",
            trigger: "blur",
          },
        ],
      },
      bindShopFormRule2: {
        stationName: [
          {
            required: true,
            message: "请填写门店名称",
            trigger: "blur",
          },
        ],
        business: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "blur",
          },
        ],
        mtBusiness: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "blur",
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择门店所在地",
            trigger: "blur",
          },
        ],
        stationAddress: [
          {
            required: true,
            message: "请填写店铺地址",
            trigger: "blur",
          },
        ],
        contactName: [
          {
            required: true,
            message: "请填写联系人姓名",
            trigger: "blur",
          },
        ],
        phone: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        startHour: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur",
          },
        ],
        endHour: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "blur",
          },
        ],
      },
      bindSSShopFormRule2: {
        stationName: [
          {
            required: true,
            message: "请填写门店名称",
            trigger: "blur",
          },
        ],
        business: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "blur",
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择门店所在地",
            trigger: "blur",
          },
        ],
        stationAddress: [
          {
            required: true,
            message: "请填写店铺地址",
            trigger: "blur",
          },
        ],
        phone: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        areaName: [
          {
            required: true,
            message: "请填写店铺门牌号",
            trigger: "blur",
          },
        ],
      },
      cityOptions: cityJson,
      cityOptionsForCode: cityJsonForCode,
      businessOptions: [],
      MTBusinessOptions: [
        {
          value: "110",
          label: "美食",
          children: [
            {
              value: "110001",
              label: "零食小吃",
            },
            {
              value: "110002",
              label: "早餐",
            },
            {
              value: "110003",
              label: "香锅/烤鱼",
            },
            {
              value: "110004",
              label: "西餐",
            },
            {
              value: "110005",
              label: "日韩料理",
            },
            {
              value: "110006",
              label: "海鲜/烧烤",
            },
            {
              value: "110007",
              label: "快餐/地方菜",
            },
            {
              value: "110008",
              label: "匹萨",
            },
          ],
        },
        {
          value: "120",
          label: "生活超市",
          children: [
            {
              value: "120001",
              label: "便利店",
            },
            {
              value: "120002",
              label: "水站/奶站",
            },
            {
              value: "120003",
              label: "零食/干果",
            },
            {
              value: "120004",
              label: "五金日用",
            },
            {
              value: "120005",
              label: "粮油调味",
            },
            {
              value: "120006",
              label: "文具店",
            },
            {
              value: "120007",
              label: "酒水/茶行",
            },
            {
              value: "120008",
              label: "地方特产",
            },
            {
              value: "120009",
              label: "进口食品",
            },
            {
              value: "120011",
              label: "超市",
            },
            {
              value: "120012",
              label: "书店",
            },
            {
              value: "120013",
              label: "传统百货",
            },
          ],
        },
        {
          value: "150",
          label: "生鲜果蔬",
          children: [
            {
              value: "150001",
              label: "果蔬",
            },
            {
              value: "150002",
              label: "海鲜水产",
            },
            {
              value: "150003",
              label: "冷冻速食",
            },
          ],
        },
        {
          value: "160",
          label: "电商",
          children: [
            {
              value: "160001",
              label: "电视购物",
            },
            {
              value: "160002",
              label: "线上商城",
            },
          ],
        },
        {
          value: "180",
          label: "鲜花绿植",
          children: [
            {
              value: "180001",
              label: "鲜花",
            },
            {
              value: "180002",
              label: "绿植",
            },
          ],
        },
        {
          value: "200",
          label: "医药健康",
          children: [
            {
              value: "200001",
              label: "OTC",
            },
          ],
        },
        {
          value: "240",
          label: "母婴",
          children: [
            {
              value: "240001",
              label: "孕婴用品",
            },
          ],
        },
        {
          value: "250",
          label: "3C家电",
          children: [
            {
              value: "250001",
              label: "手机数码",
            },
          ],
        },
        {
          value: "260",
          label: "日用品",
          children: [
            {
              value: "260002",
              label: "办公居家用品",
            },
            {
              value: "260003",
              label: "票务文件",
            },
          ],
        },
        {
          value: "270",
          label: "甜点饮品",
          children: [
            {
              value: "270001",
              label: "蛋糕",
            },
            {
              value: "270002",
              label: "甜品",
            },
            {
              value: "270003",
              label: "奶茶果汁",
            },
            {
              value: "270004",
              label: "咖啡",
            },
            {
              value: "270005",
              label: "面包/糕点",
            },
            {
              value: "270006",
              label: "冰淇淋",
            },
          ],
        },
        {
          value: "280",
          label: "美妆",
          children: [
            {
              value: "280001",
              label: "日化美妆",
            },
          ],
        },
        {
          value: "330",
          label: "快递配送",
          children: [
            {
              value: "330001",
              label: "快递包裹",
            },
          ],
        },
        {
          value: "210",
          label: "其他",
          children: [
            {
              value: "210001",
              label: "其他",
            },
          ],
        },
      ],
      mapCenter: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      isSubmit: false,
      activeName: "maiyatian",
      activeNameObj: {
        dada: "达达",
        shansong: "闪送",
        meituan: "美团",
        maiyatian: "麦芽田",
      },
      eleInfo: null,
      timer: null,
      timeCount: 60,
      allStore: [],
      isShowAPDialog: false,
    };
  },
  watch: {
    bindingMode(value, old) {
      this.$refs.bindAccountForm.resetFields();
    },
    activeName() {
      this.getPageData();
    },
  },
  components: {
    qrcode,
  },
  computed: {
    bindingMode() {
      return this.bindAccountForm.bindingMode;
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getMerchant();
      this.getMerchantForCheck();
      this.getBusiness();
      // this.getShopInfoEle();
    },
    getMerchant() {
      if (this.activeName == "dada") {
        getMerchant().then((res) => {
          if (res.code == 1) {
            this.shopList = [];
            this.shopList.push(res.data);
            this.isBindShop = true;
          } else {
            this.shopList = [];
            this.isBindShop = false;
          }
        });
      }
      if (this.activeName == "shansong") {
        getShansongMerchant().then((res) => {
          if (res.code == 1) {
            this.shopList = [];
            this.shopList.push(res.data);
            this.isBindShop = true;
          } else {
            this.shopList = [];
            this.isBindShop = false;
          }
        });
      }
      if (this.activeName == "meituan") {
        getMerchantMT().then((res) => {
          if (res.code == 1) {
            this.shopList = [];
            this.shopList.push(res.data);
            this.isBindShop = true;
          } else {
            this.shopList = [];
            this.isBindShop = false;
          }
        });
      }
      if (this.activeName == "maiyatian") {
        getMerchantMYT().then((res) => {
          if (res.code == 1) {
            this.shopList = [];
            this.shopList.push(res.data);
            this.isBindShop = true;
          } else {
            this.shopList = [];
            this.isBindShop = false;
          }
        });
      }
    },
    getMerchantForCheck() {
      if (this.activeName == "dada") {
        getMerchantForCheck().then((res) => {
          if (res.code == 1) {
            this.isBindAccount = true;
            this.bindShopForm.merchantId = res.data.merchantId;
          }
          if (res.code == -1) {
            this.isBindAccount = false;
          }
        });
      }
      if (this.activeName == "shansong") {
        getShansongMerchantForCheck().then((res) => {
          console.log(res);
          if (res.code == 1) {
            this.isBindAccount = true;
            this.bindShopForm.merchantId = res.data.merchantId;
            this.ssStatus = res.data.status;
            if (res.data.status == 3) {
              this.ssStatusObj[3] = this.ssStatusObj[3] + ` ${res.data.failedReason}`;
              let params = {};
              params.bindingMode = 0;
              params.mobile = "13888888888";
              params.smsCode = "13888888888";
              params.cityNameArryay = [
                String(res.data.provinceId) || "1",
                String(res.data.cityId) || "1",
                String(res.data.districtId) || "1",
              ];
              params.cityName = res.data.cityName;
              params.enterpriseName2 = res.data.storeName;
              params.business = res.data.goodType;
              params.enterpriseAddress = res.data.address;
              params.lat = res.data.latitude;
              params.lng = res.data.longitude;
              this.mapCenterInputText = `${res.data.lng},${res.data.lat}`;
              params.contactPhone = res.data.contactPhone;
              params.frontIdcard = res.data.frontIdcard;
              params.reverseIdcard = res.data.reverseIdcard;
              params.businessLicense = res.data.businessLicense;
              params.facade = res.data.facade;
              // Object.assign(this.bindAccountForm, params);
              this.bindAccountForm = [];
              this.bindAccountForm = params;
              console.log(this.bindAccountForm);
            }
            if (!res.data.refreshToken && res.data.status == 2) {
              this.ssAuth();
            }
          }
          if (res.code == -1) {
            this.isBindAccount = false;
          }
        });
      }
    },
    getShopInfoEle() {
      getShopInfoEle().then((res) => {
        if (res.code == 1) {
          this.eleInfo = res.data;
        }
      });
    },
    getAuthUrl() {
      getAuthUrl().then((res) => {
        if (res.code == 1) {
          location.href = res.data.url;
        }
      });
    },
    getBusiness() {
      if (this.activeName == "dada") {
        getBusiness().then((res) => {
          if (res.code == 1) {
            this.businessOptions = res.data;
          }
          if (res.code == -1) {
            this.businessOptions = [];
          }
        });
      }
      if (this.activeName == "shansong") {
        getShansongBusiness().then((res) => {
          if (res.code == 1) {
            let list = [];
            res.data.forEach((val) => {
              list.push({
                typeName: val.name,
                type: val.value,
              });
            });
            this.businessOptions = list;
          }
          if (res.code == -1) {
            this.businessOptions = [];
          }
        });
      }
      if (this.activeName == "maiyatian") {
        getMYTBusiness().then((res) => {
          if (res.code == 1) {
            this.businessOptions = res.data;
          }
          if (res.code == -1) {
            this.businessOptions = [];
          }
        });
      }
    },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      this.zoom = 12.8;
    },
    mapBCReadyHandler({ BMap, map }) {
      this.center = this.mapBCCenter;
      this.zoom = 12.8;
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.bindShopForm.stationAddress = rs.address;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.bindShopForm.lng = lng;
        this.bindShopForm.lat = lat;
      });
    },
    getBCPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.bindAccountForm.enterpriseAddress = rs.address;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.bindAccountForm.lng = lng;
        this.bindAccountForm.lat = lat;
      });
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    bindAccount() {
      this.dialogBindAccountVisible = true;
    },
    bindShop() {
      this.getAllStore();
      this.dialogBindShopVisible = true;
    },
    bindMTShop() {
      this.bindShopForm.bindingMode = 1;
      this.dialogBindShopVisible = true;
    },
    // showDialogMap() {
    //   if (!this.bindShopForm.cityNameArryay.length) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogMapVisible = true;
    // },
    // showBCDialogMap() {
    //   if (!this.bindAccountForm.cityNameArryay.length) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogBCMapVisible = true;
    // },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    saveBCStationAddress() {
      this.dialogBCMapVisible = false;
    },
    createBindAccount() {
      this.$refs.bindAccountForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.bindAccountForm));
          if (this.activeName == "dada") {
            if (params.bindingMode) {
              delete params.merchantId;
              params.enterpriseName = params.enterpriseName2;
              params.provinceId = params.cityNameArryay[0].value;
              params.cityId = params.cityNameArryay[1].value;
              params.districtId = params.cityNameArryay[2].value;
              params.provinceName = params.cityNameArryay[0].label;
              params.areaName = params.cityNameArryay[2].label;
              params.cityName = params.cityNameArryay[1].label;
              addMerchant(params).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "绑定成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindAccountVisible = false;
                  this.isBindAccount = true;
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.msg,
                    type: "warning",
                  });
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            } else {
              let bindParams = {};
              bindParams.merchantId = params.merchantId;
              bindParams.enterpriseName = params.enterpriseName1;
              bindMerchant(bindParams).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "绑定成功",
                    type: "success",
                  });
                  this.dialogBindAccountVisible = false;
                  this.isBindAccount = true;
                }
                if (res.code == 0) {
                  this.$notify({
                    title: "提示",
                    message: "只能绑定一个商户，请新增",
                    type: "warning",
                  });
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            }
          }
          if (this.activeName == "shansong") {
            if (params.bindingMode) {
              delete params.merchantId;
              params.enterpriseName = params.enterpriseName2;
              params.provinceId = params.cityNameArryay[0];
              params.cityId = params.cityNameArryay[1];
              params.districtId = params.cityNameArryay[2];
              if (this.ssStatus == 3) {
                reAddSSMerchant({
                  storeName: this.bindAccountForm.enterpriseName2,
                  cityName: params.cityName,
                  goodType: this.bindAccountForm.business,
                  address: this.bindAccountForm.enterpriseAddress,
                  latitude: this.bindAccountForm.lat,
                  longitude: this.bindAccountForm.lng,
                  contactPhone: this.bindAccountForm.contactPhone,
                  frontIdcard: this.bindAccountForm.frontIdcard,
                  reverseIdcard: this.bindAccountForm.reverseIdcard,
                  businessLicense: this.bindAccountForm.businessLicense,
                  facade: this.bindAccountForm.facade,
                  provinceId: params.provinceId,
                  cityId: params.cityId,
                  districtId: params.districtId,
                }).then((res) => {
                  if (res.code == 1) {
                    this.$notify({
                      title: "提示",
                      message: "绑定成功",
                      type: "success",
                    });
                    this.getPageData();
                    this.dialogBindAccountVisible = false;
                    this.isBindAccount = true;
                    this.getMerchantForCheck();
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                  setTimeout(() => {
                    this.isSubmit = false;
                  }, 500);
                });
              } else {
                addSSMerchant({
                  registerMobile: this.bindAccountForm.mobile,
                  smsCode: this.bindAccountForm.smsCode,
                  storeName: this.bindAccountForm.enterpriseName2,
                  cityName: params.cityName,
                  goodType: this.bindAccountForm.business,
                  address: this.bindAccountForm.enterpriseAddress,
                  latitude: this.bindAccountForm.lat,
                  longitude: this.bindAccountForm.lng,
                  contactPhone: this.bindAccountForm.contactPhone,
                  frontIdcard: this.bindAccountForm.frontIdcard,
                  reverseIdcard: this.bindAccountForm.reverseIdcard,
                  businessLicense: this.bindAccountForm.businessLicense,
                  facade: this.bindAccountForm.facade,
                  provinceId: params.provinceId,
                  cityId: params.cityId,
                  districtId: params.districtId,
                }).then((res) => {
                  if (res.code == 1) {
                    this.$notify({
                      title: "提示",
                      message: "绑定成功",
                      type: "success",
                    });
                    this.getPageData();
                    this.dialogBindAccountVisible = false;
                    this.isBindAccount = true;
                    this.getMerchantForCheck();
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                  setTimeout(() => {
                    this.isSubmit = false;
                  }, 500);
                });
              }
            } else {
              // let bindParams = {};
              // bindParams.merchantId = params.merchantId;
              // bindParams.enterpriseName = params.enterpriseName1;
              // bindMerchant(bindParams).then((res) => {
              //   if (res.code == 1) {
              //     this.$notify({
              //       title: "提示",
              //       message: "绑定成功",
              //       type: "success",
              //     });
              //     this.dialogBindAccountVisible = false;
              //     this.isBindAccount = true;
              //   }
              //   if (res.code == 0) {
              //     this.$notify({
              //       title: "提示",
              //       message: "只能绑定一个商户，请新增",
              //       type: "warning",
              //     });
              //   }
              //   setTimeout(() => {
              //     this.isSubmit = false;
              //   }, 500);
              // });
              this.ssAuth();
            }
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    ssAuth() {
      if (!!~location.href.indexOf("192.168")) {
        location.href = `http://open.s.bingex.com/auth?response_type=code&client_id=ssbJFNsYCB2l2fEjH&state=${JSON.stringify(
          {
            userId: localStorage.userId,
            url: encodeURIComponent(location.origin + location.pathname),
          }
        )}&scope=shop_open_api&thirdStoreId=&redirect_uri=http://192.168.1.103:8084/edcmanageapi/Shansong_authNotifyUrl`;
      } else {
        location.href = `http://open.ishansong.com/auth?response_type=code&client_id=ssbJFNsYCB2l2fEjH&state=${JSON.stringify(
          {
            userId: localStorage.userId,
            url: encodeURIComponent(location.origin + location.pathname),
          }
        )}&scope=shop_open_api&thirdStoreId=&redirect_uri=https://api.yichengshi.cn/edcmanageapi/Shansong_authNotifyUrl`;
      }
    },
    createBindShop() {
      console.log(this.bindShopForm);
      this.$refs.bindShopForm.validate((valid) => {
        console.log(1);
        if (valid) {
          console.log(2);
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.bindShopForm));

          if (this.activeName == "dada") {
            console.log(3, params.bindingMode);
            if (params.bindingMode == 1) {
              delete params.merchantId;
              delete params.originShopId;
              params.provinceId = params.cityNameArryay[0];
              params.cityId = params.cityNameArryay[1];
              params.districtId = params.cityNameArryay[2];
              addShop(params).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "绑定成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                  this.isBindShop = true;
                }
                if (res.code == 0) {
                  if (~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            } else if (params.bindingMode == 0) {
              let bindParams = {};
              bindParams.merchantId = params.merchantId;
              bindParams.originShopId = params.originShopId;
              bindShop(bindParams).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "绑定成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                  this.isBindShop = true;
                }
                if (res.code == 0) {
                  if (~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            } else if (params.bindingMode == 2) {
              params.provinceId = params.cityNameArryay[0];
              params.cityId = params.cityNameArryay[1];
              params.districtId = params.cityNameArryay[2];
              updateShop(params).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "编辑成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                }
                if (res.code == 0) {
                  if (~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            }
          }
          if (this.activeName == "shansong") {
            if (params.bindingMode == 1) {
              delete params.merchantId;
              delete params.originShopId;
              params.provinceId = params.cityNameArryay[0];
              params.cityId = params.cityNameArryay[1];
              params.districtId = params.cityNameArryay[2];
              addSSShop(params).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "绑定成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                  this.isBindShop = true;
                }
                if (res.code == 0) {
                  if (~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            } else if (params.bindingMode == 0) {
              let bindParams = {};
              bindParams.merchantId = params.merchantId;
              bindParams.originShopId = params.originShopId;
              bindSSShop(bindParams).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "绑定成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                  this.isBindShop = true;
                }
                if (res.code == 0) {
                  if (~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            } else if (params.bindingMode == 2) {
              params.provinceId = params.cityNameArryay[0];
              params.cityId = params.cityNameArryay[1];
              params.districtId = params.cityNameArryay[2];
              addSSShop(params).then((res) => {
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "编辑成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                }
                if (res.code == 0) {
                  if (~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res.msg,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            }
          }
          if (this.activeName == "meituan") {
            let { lng, lat } = gg2bd(this.bindShopForm.lng, this.bindShopForm.lat);
            let mtparams = {
              enterpriseAddress: params.stationAddress,
              contactName: params.contactName,
              contactPhone: params.phone,
              enterpriseName: params.stationName,
              addressDetail: params.addressDetail,
              sendType: 5,
              longitude: lng,
              latitude: lat,
              goodType: params.mtBusiness[1],
              startHour: params.startHour,
              endHour: params.endHour,
            };
            mtparams.provinceId = params.cityNameArryay[0];
            mtparams.cityId = params.cityNameArryay[1];
            mtparams.districtId = params.cityNameArryay[2];
            mtparams.provinceName = params.provinceName;
            mtparams.areaName = params.areaName;
            mtparams.cityName = params.cityName;
            console.log(mtparams, params.cityNameArryay);
            addMerchant(mtparams).then((res) => {
              console.log(res);
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "绑定成功",
                  type: "success",
                });
                this.getPageData();
                this.dialogBindShopVisible = false;
                this.isBindShop = true;
              } else {
                if (res.msg && ~res.msg.indexOf("city_name")) {
                  this.$notify({
                    title: "提示",
                    message: "该城市未开通服务",
                    type: "warning",
                  });
                } else {
                  this.$notify({
                    title: "提示",
                    message: res,
                    type: "warning",
                  });
                }
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          }
          if (this.activeName == "maiyatian") {
            let { lng, lat } = gg2bd(this.bindShopForm.lng, this.bindShopForm.lat);
            let mytparams = {
              enterpriseAddress: params.stationAddress,
              contactName: params.contactName,
              contactPhone: params.phone,
              enterpriseName: params.stationName,
              addressDetail: params.addressDetail,
              sendType: 6,
              longitude: lng,
              latitude: lat,
              goodType: params.business,
              startHour: params.startHour,
              endHour: params.endHour,
              mapType: 2,
            };
            mytparams.provinceId = params.cityNameArryay[0];
            mytparams.cityId = params.cityNameArryay[1];
            mytparams.districtId = params.cityNameArryay[2];
            mytparams.provinceName = params.provinceName;
            mytparams.areaName = params.areaName;
            mytparams.cityName = params.cityName;
            console.log(mytparams, params.cityNameArryay);
            if (params.merchantId) {
              mytparams.merchantId = params.merchantId;
            }
            if (mytparams.merchantId) {
              updateMYTShop(mytparams).then((res) => {
                console.log(res);
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "编辑成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                  this.isBindShop = true;
                } else {
                  if (res.msg && ~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            } else {
              addMYTMerchant(mytparams).then((res) => {
                console.log(res);
                if (res.code == 1) {
                  this.$notify({
                    title: "提示",
                    message: "绑定成功",
                    type: "success",
                  });
                  this.getPageData();
                  this.dialogBindShopVisible = false;
                  this.isBindShop = true;
                } else {
                  if (res.msg && ~res.msg.indexOf("city_name")) {
                    this.$notify({
                      title: "提示",
                      message: "该城市未开通服务",
                      type: "warning",
                    });
                  } else {
                    this.$notify({
                      title: "提示",
                      message: res,
                      type: "warning",
                    });
                  }
                }
                setTimeout(() => {
                  this.isSubmit = false;
                }, 500);
              });
            }
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetBindAccountForm() {
      this.bindAccountForm = {
        min: "1",
        max: "2",
        tableConfigName: "",
        shoppingTableConfigId: "",
      };
    },
    cityNameCascaderHandler(val) {
      setTimeout(() => {
        let value = this.$refs.shopCityName.$refs.input.value.split("/");
        console.log(value);
        this.bindShopForm.provinceName = value[0] ? value[0].trim() : "";
        this.bindShopForm.cityName = value[1] ? value[1].trim() : "";
        this.bindShopForm.areaName = value[2] ? value[2].trim() : "";
        console.log(value, this.bindShopForm);
        let city = [];
        value.forEach((val) => {
          city.push(val);
        });
        this.mapCenter = city.join("");
      }, 0);
    },
    cityNameForCodeCascaderHandler(value) {
      this.bindShopForm.provinceId = value[0];
      this.bindShopForm.cityId = value[1];
      this.bindShopForm.districtId = value[2] || -1;
      let cityName = "";
      this.cityOptionsForCode.forEach((val) => {
        if (val.value == value[0]) {
          cityName += val.label;
          this.bindShopForm.provinceName = val.label;
          val.children.forEach((sval) => {
            if (sval.value == value[1]) {
              cityName += sval.label;
              this.bindShopForm.cityName = sval.label;
              if (value[2] != -1) {
                sval.children.forEach((ssval) => {
                  if (ssval.value == value[2]) {
                    cityName += ssval.label;
                    this.bindShopForm.areaName = ssval.label;
                  }
                });
              }
            }
          });
        }
      });
      this.mapCenter = cityName;
    },
    cityChange(value) {
      this.bindAccountForm.cityName = value[1].label;
      setTimeout(() => {
        let value = this.$refs.BCShopCityName.$refs.input.value.split("/");
        console.log(value);
        this.bindAccountForm.provinceName = value[0] ? value[0].trim() : "";
        this.bindAccountForm.cityName = value[1] ? value[1].trim() : "";
        this.bindAccountForm.areaName = value[2] ? value[2].trim() : "";
        let city = [];
        value.forEach((val) => {
          city.push(val);
        });
        this.mapBCCenter = city.join("");
        console.log(this.bindAccountForm);
      }, 0);
    },
    handleSizeChange() {},
    handleCurrentChange() {},
    edit(index) {
      let params = JSON.parse(JSON.stringify(this.shopList[index]));
      params.bindingMode = 2;
      params.cityNameArryay = [
        String(params.provinceId) || "1",
        String(params.cityId) || "1",
        String(params.districtId) || "1",
      ];
      this.mapCenter = params.provinceName + params.cityName + params.areaName;
      if (this.activeName == "meituan" || this.activeName == "maiyatian") {
        params = Object.assign(this.bindShopForm, params, {
          stationName: JSON.parse(JSON.stringify(params.enterpriseName)),
          mtBusiness: [String(parseInt(params.goodType / 1000)), String(params.goodType)],
          business: params.goodType,
          stationAddress: params.address,
          lng: params.longitude,
          lat: params.latitude,
          contactName: params.contactName,
          phone: params.contactPhone,
        });
      }
      this.bindShopForm = {};
      this.bindShopForm = params;
      this.mapCenterInputText = params.longitude
        ? `${params.longitude},${params.latitude}`
        : params.lng
        ? `${params.lng},${params.lat}`
        : ``;
      console.log(this.bindShopForm);
      this.dialogBindShopVisible = true;
    },
    del(index) {
      updateShopUnbind({
        originShopId: this.shopList[index].originShopId,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "解绑成功",
            type: "success",
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    closeBindShopForm() {
      this.bindShopForm.resetFields();
      this.bindShopForm = {
        bindingMode: 0,
        merchantId: "",
        originShopId: "",
        stationName: "",
        business: "",
        mtBusiness: [],
        cityName: "",
        cityNameArryay: [],
        stationAddress: "",
        lng: "",
        lat: "",
        contactName: "",
        phone: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        areaName: "",
        addressDetail: "",
        startHour: "08:00",
        endHour: "23:59",
      };
    },
    handleSuccess(item, type) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      ssUploadImg(imgUploadForm).then((res) => {
        console.log(res);
        if (res.code == 1) {
          console.log(type);
          if (type == "frontIdcard") {
            this.bindAccountForm.frontIdcard = res.data.url;
          }
          if (type == "reverseIdcard") {
            this.bindAccountForm.reverseIdcard = res.data.url;
          }
          if (type == "businessLicense") {
            this.bindAccountForm.businessLicense = res.data.url;
          }
          if (type == "facade") {
            this.bindAccountForm.facade = res.data.url;
          }
        }
      });
    },
    sendRegisterSmsCode() {
      if (!/^1[3456789]\d{9}$/.test(this.bindAccountForm.mobile)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      this.timeCount = 60;
      sendRegisterSmsCode({
        mobile: this.bindAccountForm.mobile,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "success",
            duration: 2000,
          });
          this.timer = setInterval(() => {
            this.timeCount--;
            if (this.timeCount == 0) {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    getAllStore() {
      getAllStore().then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.allStore = res.data.data;
        }
      });
    },
    showAuthQrcode(url) {
      this.visibleQrcodeImg = true;
      this.qrcodeImg = url;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .el-tabs {
    margin: 10px;
  }
  .tab-content {
    display: block;
    padding: 0 20px;
  }
  .el-cascader,
  .el-select {
    width: 100%;
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
.uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
  &:hover {
    border-color: #409eff;
  }
}
.uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader .el-upload:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.uploader-img {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<style lang="less">
.delivery-page {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 160px;
  }
}
.el-form-item__content {
  .el-input-group__append {
    background: #fff;
  }
}
</style>
